import { SpendQueryType } from "../../../hooks/useCompanySpend";
import { SpendBreakdownCard } from "./SpendBreakdownCard";

export const ITSpendBreakdown = () => (
  <SpendBreakdownCard
    title="IT Spend Breakdown"
    testIdPrefix="company-detail-spend-breakdown"
    queryType={SpendQueryType.BY_CATEGORY}
  />
);
